import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de l'erreur 403.1
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-erreur4032',
  templateUrl: './erreur4032.component.html',
  styleUrls: ['./erreur4032.component.scss']
})
export class Erreur4032Component extends BaseComponent implements OnInit {

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

}
